import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import { Helmet } from "react-helmet";
import { buildBrandedFaviconDataUrl } from "../../utils/brandedFavicon";
import { pickConfigString } from "../../utils/tenancySeo";

const HeaderConfig: React.FC = () => {
  const location = useLocation();
  const payPage = location.pathname.startsWith("/pay/");
  const { tenancyConfigData } = useAppSelector((state) => ({
    tenancyConfigData: state.affiliate.multiTenancyConfigData,
  }));

  const brandedFallback = useMemo(
    () =>
      buildBrandedFaviconDataUrl(
        tenancyConfigData?.primaryColourCode ||
          tenancyConfigData?.primaryColorCode ||
          tenancyConfigData?.PrimaryColourCode,
      ),
    [
      tenancyConfigData?.primaryColourCode,
      tenancyConfigData?.primaryColorCode,
      tenancyConfigData?.PrimaryColourCode,
    ],
  );

  const [faviconHref, setFaviconHref] = useState<string>(brandedFallback);

  useEffect(() => {
    if (tenancyConfigData?.affiliateFavicon) {
      setFaviconHref(tenancyConfigData.affiliateFavicon);
    } else {
      setFaviconHref(brandedFallback);
    }
  }, [tenancyConfigData?.affiliateFavicon, brandedFallback]);

  return (
    <div>
      <Helmet>
        <title>
          {payPage
            ? "MITO PAYMENT"
            : pickConfigString(
                tenancyConfigData,
                "siteSeoTitle",
                "SiteSeoTitle",
                "siteseotitle",
              ) || tenancyConfigData?.affiliateName}
        </title>
        {payPage ? <meta property="og:title" content="MITO PAYMENT" /> : null}
        <link rel="icon" href={faviconHref} />
        <link rel="apple-touch-icon" href={faviconHref} />
      </Helmet>
    </div>
  );
};

export default HeaderConfig;
